var Sushi;

(function (Sushi, Plugins) {
	"use strict";

	var Events = Sushi.Events;

	var createInstances = function (parentElement) {
		var dateInputs = parentElement.querySelectorAll("[data-datepicker]");

		Sushi.Dom.forEach(dateInputs, function (inputElement) {
			var dayOfWeek = window.TheDatepicker.DayOfWeek;
			var datepicker = new window.TheDatepicker.Datepicker(inputElement);
			var options = datepicker.options;
			var translator = options.translator;
			var dateFormat = inputElement.getAttribute("data-datepicker-format");

			options.setInputFormat(dateFormat ? dateFormat : "m/d/Y");
			options.setFirstDayOfWeek(dayOfWeek.Sunday);
			options.setShowDeselectButton(false);
			options.setShowResetButton(true);
			translator.setDayOfWeekTranslation(dayOfWeek.Monday, "M");
			translator.setDayOfWeekTranslation(dayOfWeek.Tuesday, "T");
			translator.setDayOfWeekTranslation(dayOfWeek.Wednesday, "W");
			translator.setDayOfWeekTranslation(dayOfWeek.Thursday, "T");
			translator.setDayOfWeekTranslation(dayOfWeek.Friday, "F");
			translator.setDayOfWeekTranslation(dayOfWeek.Saturday, "S");
			translator.setDayOfWeekTranslation(dayOfWeek.Sunday, "S");

			options.onSelect(function () {
				Sushi.getPluginInstance(Plugins.FloatingLabel, inputElement).update();
				Events(inputElement).trigger("change");
			});

            datepicker.render();
		});
	};

	createInstances(document);



	/* Repeaters
	 * --------------------------- */

	Sushi.Events(document).on("Repeater.add", function (event) {
		createInstances(event.target);
	});
})(Sushi || (Sushi = {}), Sushi.Plugins || (Sushi.Plugins = {}));
